module.exports = __webpack_public_path__ + "static/media/reddit.a0fcce1d.png";